import _ from 'lodash';

import Popup from '~makosh/assets/components/popup/popup';

export default class SWFPopup extends Popup {
    constructor(options = {}) {
        super({noInit: true});
        this.init(Object.assign({
            class: 'swf-popup group',
            content: _.template('<object width="<%- width %>" height="<%- height %>">'
                + '<param name="movie"'
                    + ' value="<%- url %>">'
                + '<embed src="<%- url %>"'
                    + ' width="<%- width %>" height="<%- height %>">'
            + '</object>')(options),
        }, options));
    }
}



// WEBPACK FOOTER //
// ./legacy/assets/components/swf-popup.js